import { getConfig } from '../config';

export function stripeChargeUrl(chargeId) {
  return `${getConfig().stripe.dashboardUrl}/payments/${chargeId}`;
}

export function stripeCustomerUrl(customerId) {
  return `${getConfig().stripe.dashboardUrl}/customers/${customerId}`;
}
